// src/features/Task/Taskslice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTasks,
  addTask,
  updateTask,
  deleteTask,
  getTaskHistoryById,
} from "./taskApi";

// Thunks
export const fetchTasks = createAsyncThunk(
  "Tasks/fetchTasks",
  async (paramsOptions) => {
    const response = await getTasks(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const fetchTaskHistoryById = createAsyncThunk(
  "projects/fetchTaskHistoryById",
  async (paramsOptions) => {
    const response = await getTaskHistoryById(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const createTask = createAsyncThunk(
  "tasks/createTask",
  async (formData) => {
    const response = await addTask(formData); 
    return response;
  }
);

export const updateTaskData = createAsyncThunk(
  "tasks/updateTask",
  async (formData) => {
    const response = await updateTask(formData);
    return response;
  }
);

export const deleteTaskById = createAsyncThunk(
  "Tasks/deleteTask",
  async (id) => {
    const response = await deleteTask(id);
    return response;
  }
);

const Taskslice = createSlice({
  name: "Tasks",
  initialState: {
    tasks: [],
    taskHistory: [],
    pagination: {},
    taskHistoryPagination: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTasks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTasks.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.tasks = data;
        state.pagination = pagination;
      })
      .addCase(fetchTaskHistoryById.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.taskHistory = data;
        state.taskHistoryPagination = pagination;
      })
      .addCase(createTask.fulfilled, (state, action) => {
        state.tasks.push(action.payload.data);
      })
      .addCase(updateTaskData.fulfilled, (state, action) => {
        const idx = state.tasks.findIndex((u) => u.id === action.payload.id);
        if (idx !== -1) {
          state.tasks[idx] = action.payload.data;
        }
      })
      .addCase(deleteTaskById.fulfilled, (state, action) => {
        state.tasks = state.tasks.filter((u) => u.id !== action.payload.id);
      });
  },
});

export default Taskslice.reducer;
